<template>
  <div class="search-table">
    <input
      :value="value"
      class="search"
      placeholder="Имя пациента или номер заявки"
      @input="input($event.target.value)"
    >
    <SearchIcon />
  </div>
</template>

<script>
  import SearchIcon from '@/icons/search.svg';
  let timeout = null;

  export default {
    name: 'OrdersSearch',
    components: {SearchIcon},
    props: {
      value: String,
    },
    methods: {
      input(value) {
        clearTimeout(timeout);
        timeout = setTimeout(async () => {
          this.$emit('input', value);
        }, 400);
      },
    },
  };
</script>

<style lang="scss">
  .search-table {
    input {
      display: inline-block;
    }
    z-index: 10;
    .search{
      height: 100%;
      padding: 12px 16px;
      border-radius: 4px;
      outline: none;
      border: none;
      transition: .2s;
      width: 100%;
    }

    .search:hover{
      box-shadow: 0px 4px 12px rgba(32, 37, 58, 0.08);
    }
    .search:focus{
      box-shadow: 0px 4px 12px rgba(32, 37, 58, 0.16);
    }

    .search-icon{
      position: absolute;
      left: 12px;
      top: 50%;
      transform: translateY(-50%);
    }

    .search{
      padding-left: 36px;
    }

    ::placeholder {
      color: #A0A5BA;
      font-weight: 300;
    }
  }
</style>
